export const encodeUrl = (url) => {
  const regex = /[^a-zA-Z0-9]+/g;
  return url.replace(regex, "-").replace(/-+/g, "-").replace(/^-|-$/g, "");
};

export const transImgUrl = (url) => {
  if (!url || typeof url !== "string") return "";
  const normalizedUrl = url.startsWith("/") ? url : `/${url}`;
  return url.startsWith("http")
    ? url
    : `https://file.aichiplink.com${normalizedUrl}`;
};
